var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('json-editor',{attrs:{"placeholder":""},model:{value:(_vm.jsonText),callback:function ($$v) {_vm.jsonText=$$v},expression:"jsonText"}})}
var staticRenderFns = []

export { render, staticRenderFns }